module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "admin"
    }
  }, [_c('div', {
    attrs: {
      "id": "announcement",
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-row', [_c('h2', [_vm._v("預覽：")]), _vm._v(" "), _c('announcement')], 1), _c('br'), _vm._v(" "), _c('el-row', [_c('h2', [_vm._v("設定：")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.announcement,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ("公告標題 (" + _vm.titleLength + "/15字)"),
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "限10字"
    },
    model: {
      value: (_vm.title['.value']),
      callback: function($$v) {
        var $$exp = _vm.title,
          $$idx = '.value';
        if (!Array.isArray($$exp)) {
          _vm.title['.value'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "title['.value']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ("公告內容 (" + _vm.detailLength + "/50字)"),
      "prop": "detail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "請輸入公告內容"
    },
    model: {
      value: (_vm.detail['.value']),
      callback: function($$v) {
        var $$exp = _vm.detail,
          $$idx = '.value';
        if (!Array.isArray($$exp)) {
          _vm.detail['.value'] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "detail['.value']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密碼"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "密碼"
    },
    model: {
      value: (_vm.pwd),
      callback: function($$v) {
        _vm.pwd = $$v
      },
      expression: "pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateAnnouncement()
      }
    }
  }, [_vm._v("更新")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bb44c48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminView.vue
// module id = 973
// module chunks = 1